import { Image, isWeb, Text, View, YStack } from "@medbillai/ui";
import { getLogoLetter, getLogoSlug } from "../../../lib/accounts-link/utils";
import { imageAssets } from "../../../logo-assets/logo-manifest/manifest";
import type { AccountLogoProps } from "../utils/types";
export const AccountLogo = ({
  endpoint,
  style,
  imageStyle,
  orgSlug,
  maintainAspectRatio = false
}: AccountLogoProps) => {
  const endpointSlug = getLogoSlug(endpoint, orgSlug);
  const endpointLetter = getLogoLetter(endpoint, orgSlug);
  const imageHeight = imageStyle?.height || 43;
  const logoAsset = imageAssets[endpointSlug];
  const aspectRatio = logoAsset?.aspectRatio || 1;
  const imageWidth = maintainAspectRatio ? imageHeight * aspectRatio : imageHeight;
  // Check that not only is a slug passed but that its valid and found in manifest
  const hasLogo = isWeb ? !!logoAsset : !!logoAsset?.asset;
  return <View overflow="hidden" alignSelf={maintainAspectRatio ? "flex-start" : undefined} {...style} data-sentry-element="View" data-sentry-component="AccountLogo" data-sentry-source-file="AccountLogo.tsx">
      {hasLogo ? isWeb ? <Image src={`/static/logos/${endpointSlug}.png`} width={imageWidth} height={imageHeight} objectFit="contain" backgroundColor="transparent" {...imageStyle} /> : <Image
    // @ts-expect-error - NodeRequire is valid for React Native Image source
    src={logoAsset.asset} width={imageWidth} height={imageHeight} objectFit="contain" backgroundColor="white" {...imageStyle} /> : <YStack width={imageWidth} height={imageHeight} justifyContent="center" alignItems="center" {...imageStyle}>
          <Text fontFamily="$text" fontSize={imageStyle?.height ? (imageStyle?.height || 0) - 20 : isWeb ? "$3" : "$5"} bold>
            {endpointLetter}
          </Text>
        </YStack>}
    </View>;
};